const MASCOT_URL = "https://customer-assets.emergentagent.com/job_meal-manager-37/artifacts/ls65y5w5_image.png";

const t = {
  fr: {
    tagline: "Moderniser les Programmes de Repas Scolaires",
    copy: "\u00a9 2026 EcoLunch. Tous droits réservés.",
    links: ["Nous Contacter", "Politique de Confidentialité", "Conditions d'Utilisation"],
  },
  en: {
    tagline: "Modernizing School Meal Programs",
    copy: "\u00a9 2026 EcoLunch. All rights reserved.",
    links: ["Contact Us", "Privacy Policy", "Terms of Use"],
  },
};

export default function Footer({ lang }) {
  const c = t[lang];
  return (
    <footer data-testid="footer" className="py-12 sm:py-16 bg-soft border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <img src={MASCOT_URL} alt="EcoLunch" className="h-12 w-auto mx-auto mb-4" />
        <p className="text-lg font-bold text-white mb-2">{c.tagline}</p>
        <p className="text-sm text-white/50 mb-6">{c.copy}</p>
        <div className="flex flex-wrap justify-center gap-6">
          {c.links.map((link) => (
            <a key={link} href="#" className="text-sm text-white/50 hover:text-primary transition-colors">{link}</a>
          ))}
        </div>
      </div>
    </footer>
  );
}
